<template>
    <span class="d-inline-block" v-if="submenu && !$vuetify.breakpoint.mobile">
        <v-icon small left v-if="icon">{{icon}}</v-icon>
        {{title}}
    </span>
    <span v-else-if="!$vuetify.breakpoint.mobile">
        <router-link :to="safeLink" v-slot="{ navigate, isExactActive }" v-if="!$root.edit && visibleSubItems.length == 0">
            <div class="d-inline-block">
                <v-btn
                    text
                    block
                    :icon="!!icon && !title"
                    :x-large="!icon || !!title"
                    class="font-weight-bold hidden-sm-and-down d-inline"
                    :style="{ 'text-transform': uppercase ? 'uppercase' : 'none', 'color': isExactActive ? `${activeColor} !important` : color + ' !important'}"
                    @click="onClick(navigate, $event)"
                >
                    <v-icon small left v-if="icon">{{icon}}</v-icon>
                    <span v-if="!!title">{{title}}</span>
                </v-btn>
            </div>
        </router-link>

        <v-menu v-if="visibleSubItems.length > 0 || $root.edit"
            bottom
            left
            offset-y
            open-on-hover
            :key="menuKey"
        >
            <template v-slot:activator="{ on }">
                <router-link :to="safeLink" v-slot="{ isExactActive }">
                    <div class="d-inline-block">
                        <v-btn
                            text
                            :color="color"
                            x-large
                            class="font-weight-bold hidden-sm-and-down d-inline"
                            v-on="on"
                            @click="onClick(followLink, $event)"
                            :style="{ 'text-transform': uppercase ? 'uppercase' : 'none', 'color': isExactActive || subitemActive ? `${activeColor} !important` : color + ' !important'}"
                        >
                            <v-icon small left v-if="icon">{{icon}}</v-icon>
                            <span v-zoezi-editable="{prop: 'title', html: false, multiline: false}">{{title}}</span>
                        </v-btn>
                    </div>
                </router-link>
            </template>

            <v-list :color="backgroundColor">
                <draggable v-model="draggableSubItems" @change="$emit('silentsave', {subitems: draggableSubItems })" :disabled="!$root.edit" group="menuitem">
                    <router-link v-for="(item, i) in visibleSubItems"  :key="i" :to="item.props.link || '/'" v-slot="{ navigate, isExactActive }">
                        <v-list-item
                            :style="{ 'text-transform': uppercase ? 'uppercase' : 'none', 'color': isExactActive ? `${activeColor} !important` : color + ' !important'}"
                            @click="onClickInner(navigate, $event)"
                        >
                            <v-list-item-title>
                                <component-wrapper
                                    :config="item"
                                    class="d-inline-block"
                                    can-remove
                                    v-on:remove="removeMenuItem(i)"
                                />

                            </v-list-item-title>
                        </v-list-item>
                    </router-link>
                </draggable>

                <v-list-item v-if="$root.edit">
                    <v-btn
                        class="hidden-sm-and-down my-2"
                        @click="$emit('action', 'addsubmenuitem')"
                        fab
                        color="zoezi-edit-color"
                        small
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>
        </v-menu>
    </span>
    <v-list-item
        v-else-if="!subitems || subitems.length == 0"
        :style="{'text-transform': uppercase ? 'uppercase' : 'none', 'color': color + ' !important'}"
    >
        <router-link :to="safeLink" v-slot="{ isExactActive }">
            <v-list-item-title
                :style="{ color: isExactActive ? activeColor + ' !important' : undefined}"
                @click="followLinkAndClose()"
            >
                <v-icon small left v-if="icon">{{icon}}</v-icon>{{title}}
            </v-list-item-title>
        </router-link>
    </v-list-item>
    <v-list-group
        v-else-if="subitems && subitems.length > 0"
        :key="title"
        no-action
        :color="color"
    >
        <template v-slot:activator>
            <v-list-item-content
                :style="{ 'text-transform': uppercase ? 'uppercase' : 'none', 'margin-bottom': '0px', 'color': color + ' !important'}"
            >
                <v-list-item-title @click="followLink">
                <v-icon small left v-if="icon">{{icon}}</v-icon>
                {{title}}
                </v-list-item-title>
            </v-list-item-content>
        </template>

        <router-link v-for="(item, i) in visibleSubItems"  :key="i" :to="item.props.link || '/'" v-slot="{ navigate, isExactActive }">
            <v-list-item
                :style="{ 'text-transform': uppercase ? 'uppercase' : 'none', 'color': isExactActive ? `${activeColor} !important` : color + ' !important'}"
                @click="onClickInner(navigate, $event)"
            >
                <component-wrapper
                    :config="item"
                    can-remove
                    v-on:remove="removeMenuItem(i)"
                />
            </v-list-item>
        </router-link>

    </v-list-group>
</template>

<script>
  import Draggable from 'vuedraggable'

  export default {
    name: 'zoezi-menuitem',

    zoezi: {
        title: 'Menu choice',
        icon: 'mdi-menu-down'
    },

    components: {
        Draggable,
    },

    props: {
        title: {
            title: 'Title',
            type: String,
            default: () => window.$translate('New menu option')
        },
        icon: {
            title: 'Icon',
            type: String,
            fulltype: 'icon'
        },
        link: {
            title: 'Link',
            type: String,
            fulltype: 'page',
            default: '/'
        },
        subitems: {
            title: 'Submenu',
            type: Array,
            default: () => []
        }
    },

    watch: {
        subitems: {
            immediate: true,
            handler(subitems) {
                this.draggableSubItems = subitems?.concat();
            }
        }
    },

    data: () => ({
        menuKey: 0,
        id: 0,
        draggableSubItems: null
    }),
    mounted() {
        this.id = '0'.repeat(64).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
    },
    computed: {
        subitemActive() {
            return this.subitems && !!this.subitems.find(x => x.props.link == this.$route.path);
        },
        submenu() {
            let isParentAMenuItem = function(o) {
                if (!o) {
                    return false;
                }
                if (o.$options.name == 'zoezi-menuitem') {
                    return true;
                }

                return isParentAMenuItem(o.$parent);
            };
            return isParentAMenuItem(this.$parent);
        },
        visibleSubItems() {
            return this.subitems;
        },
        color() {
            return this.$root.colorToHex(this.$root.siteconfig.appbar.props.color);
        },
        activeColor() {
            return this.$root.colorToHex(this.$root.siteconfig.appbar.props.activeColor);
        },
        uppercase() {
            return this.$root.siteconfig.appbar.props.uppercase;
        },
        backgroundColor() {
            return this.$root.colorToHex(this.$root.siteconfig.appbar.props.backgroundColor);
        },
        safeLink() {
            return this.link || '/';
        }
    },
    methods: {
        followLink() {
            if (this.$route.path != this.safeLink) {
                this.$router.push({path: this.safeLink});
            }
        },
        followLinkAndClose() {
            this.followLink();
            this.$store.commit('setShowMobileMenu', false)
        },
        onClickInner(navigate, $event) {
            if (navigate) {
                navigate($event);
            }
        },
        onClick(navigate, $event) {
            if (navigate) {
                navigate($event);
            }
            this.$emit('select', this);
        },
        removeMenuItem(index) {
            this.subitems.splice(index, 1);
            this.$root.saveHomePage();
        }
    }
  }
</script>
